import { useContext } from 'react';
import { SnackMessageContext } from '../contexts/snackMessage/SnackMessageContext';

const useSnackbar = () => {
  const { push } = useContext(SnackMessageContext);

  return push;
};
export default useSnackbar;
